import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import { VueFire, VueFireAuth } from 'vuefire'
import { firebaseApp } from './firebase'
import { logger } from './utils/logger'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import VueApexCharts from "vue3-apexcharts";

// PrimeVue imports
import PrimeVue from 'primevue/config'
import PrecisionAuthority from './theme/precision-preset'
import 'primeicons/primeicons.css'
import './public/assets/css/tailwind.css'
import Menu from 'primevue/menu'

// Components
import ToastService from 'primevue/toastservice'
import PanelMenu from 'primevue/panelmenu'
import SplitButton from 'primevue/splitbutton'
import ProgressBar from 'primevue/progressbar'
import AutoComplete from 'primevue/autocomplete'
import DatePicker from 'primevue/datepicker'
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ProgressSpinner from 'primevue/progressspinner'
import Select from 'primevue/select'
import SelectButton from 'primevue/selectbutton';
import Toast from 'primevue/toast'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import MultiSelect from 'primevue/multiselect'
import Card from 'primevue/card'
import Tooltip from 'primevue/tooltip'
import Tag from 'primevue/tag';
let app
const auth = getAuth(firebaseApp)

// Function to register components
function registerComponents(app) {
  app.component('AutoComplete', AutoComplete)
    .component('DatePicker', DatePicker)
    .component('DataTable', DataTable)
    .component('Column', Column)
    .component('ProgressSpinner', ProgressSpinner)
    .component('Select', Select)
    .component('ProgressBar', ProgressBar)
    .component('SplitButton', SplitButton)
    .component('Toast', Toast)
    .component('Button', Button)
    .component('Tag', Tag)
    .component('Dialog', Dialog)
    .component('SelectButton', SelectButton)
    .component('InputText', InputText)
    .component('MultiSelect', MultiSelect)
    .component('Card', Card)
    .component('PanelMenu', PanelMenu)
    .component('Menu', Menu)
    .directive('tooltip', Tooltip);
}

onAuthStateChanged(auth, (user) => {
  if (!app) {
    app = createApp(App);

    // Initialize Sentry before any plugins/mount so Vue errors and router navigations are captured.
    // DSNs are ingest-only and safe to embed in client bundles.
    Sentry.init({
      app,
      dsn: 'https://5073eba97e542ad01e77e289f9f2c75e@o4511217758896128.ingest.us.sentry.io/4511217788977152',
      environment: process.env.NODE_ENV || 'production',
      release: process.env.VUE_APP_RELEASE,
      sendDefaultPii: true,
      tracesSampleRate: 0,
    });

    app
      .use(VueFire, {
        firebaseApp,
        modules: [VueFireAuth()],
      })
      .use(router)
      .use(createPinia())
      .use(PrimeVue, {
        theme: {
          preset: PrecisionAuthority,
          options: {
            prefix: 'p',
            darkModeSelector: '.dark',
            order: 'tailwind-base, primevue, tailwind-utilities'
          }
        }
      })
      .use(VueApexCharts);

    registerComponents(app);
    app.use(ToastService);
    app.mount('#app');
  }
}, (error) => {
  logger.error("Failed to authenticate or initialize the app:", error);
});
